// The live search's company-industry filter is an ENUM: values must match
// this list exactly (extracted from the provider's API spec, Sept 2026).
// Surfaced as autocomplete suggestions on the Industries chip input.
export const LIVE_SEARCH_INDUSTRIES: string[] = [
  "Abrasives and Nonmetallic Minerals Manufacturing",
  "Accessible Architecture and Design",
  "Accessible Hardware Manufacturing",
  "Accommodation and Food Services",
  "Accounting",
  "Administration of Justice",
  "Administrative and Support Services",
  "Advertising Services",
  "Agricultural Chemical Manufacturing",
  ">-",
  "Airlines and Aviation",
  "Airlines/Aviation",
  "Air; Water; and Waste Program Management",
  "Alternative Dispute Resolution",
  "Alternative Fuel Vehicle Manufacturing",
  "Alternative Medicine",
  "Ambulance Services",
  "Amusement Parks and Arcades",
  "Animal Feed Manufacturing",
  "Animation",
  "Animation and Post-production",
  "Apparel and Fashion",
  "Apparel Manufacturing",
  ">-",
  "Architectural and Structural Metal Manufacturing",
  "Architecture and Planning",
  "Armed Forces",
  ">-",
  "Artists and Writers",
  "Arts and Crafts",
  "Audio and Video Equipment Manufacturing",
  "Automation Machinery Manufacturing",
  "Automotive",
  "Aviation and Aerospace",
  "Aviation and Aerospace Component Manufacturing",
  "Baked Goods Manufacturing",
  "Banking",
  "Bars; Taverns; and Nightclubs",
  "Bed-and-Breakfasts; Hostels; Homestays",
  "Beverage Manufacturing",
  "Biomass Electric Power Generation",
  "Biotechnology",
  "Biotechnology Research",
  "Blockchain Services",
  "Blogs",
  ">-",
  "Book and Periodical Publishing",
  "Book Publishing",
  "Breweries",
  "Broadcast Media",
  "Broadcast Media Production and Distribution",
  "Building Construction",
  "Building Equipment Contractors",
  "Building Finishing Contractors",
  "Building Materials",
  "Building Structure and Exterior Contractors",
  "Business Consulting and Services",
  "Business Content",
  "Business Intelligence Platforms",
  "Business Supplies and Equipment",
  "Cable and Satellite Programming",
  "Capital Markets",
  "Caterers",
  "Chemical Manufacturing",
  "Chemical Raw Materials Manufacturing",
  "Chemicals",
  "Child Day Care Services",
  "Chiropractors",
  "Circuses and Magic Shows",
  "Civic and Social Organization",
  "Civic and Social Organizations",
  "Civil Engineering",
  "Claims Adjusting; Actuarial Services",
  "Clay and Refractory Products Manufacturing",
  "Climate Data and Analytics",
  "Climate Technology Product Manufacturing",
  "Coal Mining",
  "Collection Agencies",
  "Commercial and Industrial Equipment Rental",
  "Commercial and Industrial Machinery Maintenance",
  ">-",
  "Commercial Real Estate",
  "Communications Equipment Manufacturing",
  "Community Development and Urban Planning",
  "Community Services",
  "Computer and Network Security",
  "Computer Games",
  "Computer Hardware",
  "Computer Hardware Manufacturing",
  "Computer Networking",
  "Computer Networking Products",
  "Computers and Electronics Manufacturing",
  "Computer Software",
  "Conservation Programs",
  "Construction",
  "Construction Hardware Manufacturing",
  "Consumer Electronics",
  "Consumer Goods",
  "Consumer Goods Rental",
  "Consumer Services",
  "Correctional Institutions",
  "Cosmetics",
  "Cosmetology and Barber Schools",
  "Courts of Law",
  "Credit Intermediation",
  "Cutlery and Handtool Manufacturing",
  "Dairy",
  "Dairy Product Manufacturing",
  "Dance Companies",
  "Data Infrastructure and Analytics",
  "Data Security Software Products",
  "Death Care Services",
  "Defense and Space",
  "Defense and Space Manufacturing",
  "Dentists",
  "Design",
  "Design Services",
  "Desktop Computing Software Products",
  "Digital Accessibility Services",
  "Distilleries",
  "Economic Programs",
  "Education",
  "Education Administration Programs",
  "Education Management",
  "E-learning",
  "E-Learning Providers",
  "Electrical and Electronic Manufacturing",
  "Electrical Equipment Manufacturing",
  "Electric Lighting Equipment Manufacturing",
  "Electric Power Generation",
  ">-",
  "Electronic and Precision Equipment Maintenance",
  "Embedded Software Products",
  "Emergency and Relief Services",
  "Energy Technology",
  "Engineering Services",
  ">-",
  "Entertainment",
  "Entertainment Providers",
  "Environmental Quality Programs",
  "Environmental Services",
  "Equipment Rental Services",
  "Events Services",
  "Executive Office",
  "Executive Offices",
  "Executive Search Services",
  "Fabricated Metal Products",
  "Facilities Services",
  "Family Planning Centers",
  "Farming",
  "Farming; Ranching; Forestry",
  "Fashion Accessories Manufacturing",
  "Financial Services",
  "Fine Art",
  "Fine Arts Schools",
  "Fire Protection",
  "Fisheries",
  "Fishery",
  "Flight Training",
  "Food and Beverage Manufacturing",
  "Food and Beverage Retail",
  "Food and Beverages",
  "Food and Beverage Services",
  "Food Production",
  "Footwear and Leather Goods Repair",
  "Footwear Manufacturing",
  "Forestry and Logging",
  "Fossil Fuel Electric Power Generation",
  "Freight and Package Transportation",
  "Fruit and Vegetable Preserves Manufacturing",
  "Fuel Cell Manufacturing",
  "Fundraising",
  "Funds and Trusts",
  "Funeral Services",
  "Furniture",
  "Furniture and Home Furnishings Manufacturing",
  "Gambling and Casinos",
  "Gambling Facilities and Casinos",
  "Geothermal Electric Power Generation",
  "Glass; Ceramics and Concrete",
  "Glass; Ceramics and Concrete Manufacturing",
  "Glass Product Manufacturing",
  "Golf Courses and Country Clubs",
  "Government Administration",
  "Government Relations",
  "Government Relations Services",
  "Graphic Design",
  "Ground Passenger Transportation",
  "Health and Human Services",
  "Health; Wellness and Fitness",
  "Higher Education",
  "Highway; Street; and Bridge Construction",
  "Historical Sites",
  "Holding Companies",
  "Home Health Care Services",
  "Horticulture",
  "Hospital and Health Care",
  "Hospitality",
  "Hospitals",
  "Hospitals and Health Care",
  "Hotels and Motels",
  ">-",
  "Household Appliance Manufacturing",
  "Household Services",
  "Housing and Community Development",
  "Housing Programs",
  "Human Resources",
  "Human Resources Services",
  "HVAC and Refrigeration Equipment Manufacturing",
  "Hydroelectric Power Generation",
  "Import and Export",
  "Individual and Family Services",
  "Industrial Automation",
  "Industrial Machinery Manufacturing",
  "Industry Associations",
  "Information Services",
  "Information Technology and Services",
  "Insurance",
  "Insurance Agencies and Brokerages",
  "Insurance and Employee Benefit Funds",
  "Insurance Carriers",
  "Interior Design",
  "International Affairs",
  "International Trade and Development",
  "Internet",
  "Internet Marketplace Platforms",
  "Internet News",
  "Internet Publishing",
  "Interurban and Rural Bus Services",
  "Investment Advice",
  "Investment Banking",
  "Investment Management",
  "IT Services and IT Consulting",
  "IT System Custom Software Development",
  "IT System Data Services",
  "IT System Design Services",
  "IT System Installation and Disposal",
  "IT System Operations and Maintenance",
  "IT System Testing and Evaluation",
  "IT System Training and Support",
  "Janitorial Services",
  "Judiciary",
  "Landscaping Services",
  "Language Schools",
  "Laundry and Drycleaning Services",
  "Law Enforcement",
  "Law Practice",
  "Leasing Non-residential Real Estate",
  "Leasing Residential Real Estate",
  "Leather Product Manufacturing",
  "Legal Services",
  "Legislative Offices",
  "Leisure; Travel and Tourism",
  "Libraries",
  "Lime and Gypsum Products Manufacturing",
  "Loan Brokers",
  "Logistics and Supply Chain",
  "Luxury Goods and Jewelry",
  "Machinery",
  "Machinery Manufacturing",
  "Magnetic and Optical Media Manufacturing",
  "Management Consulting",
  "Manufacturing",
  "Maritime",
  "Maritime Transportation",
  "Marketing and Advertising",
  "Marketing Services",
  "Market Research",
  "Mattress and Blinds Manufacturing",
  "Measuring and Control Instrument Manufacturing",
  "Meat Products Manufacturing",
  "Mechanical Or Industrial Engineering",
  "Media and Telecommunications",
  "Media Production",
  "Medical and Diagnostic Laboratories",
  "Medical Device",
  "Medical Equipment Manufacturing",
  "Medical Practice",
  "Medical Practices",
  "Mental Health Care",
  "Metal Ore Mining",
  "Metal Treatments",
  "Metal Valve; Ball; and Roller Manufacturing",
  "Metalworking Machinery Manufacturing",
  "Military",
  "Military and International Affairs",
  "Mining",
  "Mining and Metals",
  "Mobile Computing Software Products",
  "Mobile Food Services",
  "Mobile Games",
  "Mobile Gaming Apps",
  "Motion Pictures and Film",
  "Motor Vehicle Manufacturing",
  "Motor Vehicle Parts Manufacturing",
  "Movies and Sound Recording",
  "Movies; Videos; and Sound",
  "Museums",
  "Museums and Institutions",
  "Museums; Historical Sites; and Zoos",
  "Music",
  "Musicians",
  "Nanotechnology",
  "Nanotechnology Research",
  "Natural Gas Distribution",
  "Natural Gas Extraction",
  "Newspaper Publishing",
  "Newspapers",
  "Nonmetallic Mineral Mining",
  "Non-profit Organization Management",
  "Non-profit Organizations",
  "Nonresidential Building Construction",
  "Nuclear Electric Power Generation",
  "Nursing Homes and Residential Care Facilities",
  "Office Administration",
  "Office Furniture and Fixtures Manufacturing",
  "Oil and Coal Product Manufacturing",
  "Oil and Energy",
  "Oil and Gas",
  "Oil Extraction",
  "Oil; Gas; and Mining",
  "Online and Mail Order Retail",
  "Online Audio and Video Media",
  "Online Media",
  "Operations Consulting",
  "Optometrists",
  "Other",
  "Outpatient Care Centers",
  "Outsourcing and Offshoring Consulting",
  "Outsourcing/Offshoring",
  "Package/Freight Delivery",
  "Packaging and Containers",
  "Packaging and Containers Manufacturing",
  "Paint; Coating; and Adhesive Manufacturing",
  "Paper and Forest Product Manufacturing",
  "Paper and Forest Products",
  "Parts Distribution",
  "Pension Funds",
  "Performing Arts",
  "Performing Arts and Spectator Sports",
  "Periodical Publishing",
  "Personal and Laundry Services",
  "Personal Care Product Manufacturing",
  "Personal Care Services",
  "Pet Services",
  "Pharmaceutical Manufacturing",
  "Pharmaceuticals",
  "Philanthropic Fundraising Services",
  "Philanthropy",
  "Photography",
  "Physical; Occupational and Speech Therapists",
  "Physicians",
  "Pipeline Transportation",
  "Plastics",
  "Plastics and Rubber Product Manufacturing",
  "Plastics Manufacturing",
  "Political Organization",
  "Political Organizations",
  "Postal Services",
  "Primary and Secondary Education",
  "Primary Metal Manufacturing",
  "Primary/Secondary Education",
  "Printing",
  "Printing Services",
  "Professional Organizations",
  "Professional Services",
  "Professional Training and Coaching",
  "Program Development",
  "Public Assistance Programs",
  "Public Health",
  "Public Policy",
  "Public Policy Offices",
  "Public Relations and Communications",
  "Public Relations and Communications Services",
  "Public Safety",
  "Public Works",
  "Publishing",
  "Racetracks",
  "Radio and Television Broadcasting",
  "Railroad Equipment Manufacturing",
  "Railroad Manufacture",
  "Rail Transportation",
  "Ranching",
  "Ranching and Fisheries",
  "Real Estate",
  "Real Estate Agents and Brokers",
  "Real Estate and Equipment Rental Services",
  "Recreational Facilities",
  "Recreational Facilities and Services",
  "Regenerative Design",
  "Religious Institutions",
  "Renewable Energy Equipment Manufacturing",
  "Renewable Energy Power Generation",
  "Renewable Energy Semiconductor Manufacturing",
  "Renewables and Environment",
  "Repair and Maintenance",
  "Research",
  "Research Services",
  "Residential Building Construction",
  "Restaurants",
  "Retail",
  "Retail Apparel and Fashion",
  ">-",
  "Retail Art Dealers",
  "Retail Art Supplies",
  "Retail Books and Printed News",
  "Retail Building Materials and Garden Equipment",
  "Retail Florists",
  "Retail Furniture and Home Furnishings",
  "Retail Gasoline",
  "Retail Groceries",
  "Retail Health and Personal Care Products",
  "Retail Luxury Goods and Jewelry",
  "Retail Motor Vehicles",
  "Retail Musical Instruments",
  "Retail Office Equipment",
  "Retail Office Supplies and Gifts",
  "Retail Pharmacies",
  "Retail Recyclable Materials and Used Merchandise",
  "Reupholstery and Furniture Repair",
  "Robotics Engineering",
  "Robot Manufacturing",
  "Rubber Products Manufacturing",
  "Satellite Telecommunications",
  "Savings Institutions",
  "School and Employee Bus Services",
  "Seafood Product Manufacturing",
  "Secretarial Schools",
  "Securities and Commodity Exchanges",
  "Security and Investigations",
  "Security Guards and Patrol Services",
  "Security Systems Services",
  "Semiconductor Manufacturing",
  "Semiconductors",
  "Services for Renewable Energy",
  "Services for the Elderly and Disabled",
  "Sheet Music Publishing",
  "Shipbuilding",
  ">-",
  "Sightseeing Transportation",
  "Skiing Facilities",
  "Smart Meter Manufacturing",
  "Soap and Cleaning Product Manufacturing",
  "Social Networking Platforms",
  "Software Development",
  "Solar Electric Power Generation",
  "Sound Recording",
  "Space Research and Technology",
  "Specialty Trade Contractors",
  "Spectator Sports",
  "Sporting Goods",
  "Sporting Goods Manufacturing",
  "Sports",
  "Sports and Recreation Instruction",
  "Sports Teams and Clubs",
  "Spring and Wire Product Manufacturing",
  "Staffing and Recruiting",
  "Steam and Air-Conditioning Supply",
  "Strategic Management Services",
  "Subdivision of Land",
  "Sugar and Confectionery Product Manufacturing",
  "Supermarkets",
  "Surveying and Mapping Services",
  "Taxi and Limousine Services",
  "Technical and Vocational Training",
  "Technology; Information and Internet",
  "Technology; Information and Media",
  "Telecommunications",
  "Telecommunications Carriers",
  "Telephone Call Centers",
  "Temporary Help Services",
  "Textile Manufacturing",
  "Textiles",
  "Theater Companies",
  "Think Tanks",
  "Tobacco",
  "Tobacco Manufacturing",
  "Translation and Localization",
  "Transportation Equipment Manufacturing",
  ">-",
  "Transportation Programs",
  "Transportation/Trucking/Railroad",
  "Travel Arrangements",
  "Truck Transportation",
  "Trusts and Estates",
  "Turned Products and Fastener Manufacturing",
  "Urban Transit Services",
  "Utilities",
  "Utilities Administration",
  "Utility System Construction",
  "Vehicle Repair and Maintenance",
  "Venture Capital and Private Equity",
  "Venture Capital and Private Equity Principals",
  "Veterinary",
  "Veterinary Services",
  "Vocational Rehabilitation Services",
  "Warehousing",
  "Warehousing and Storage",
  "Waste Collection",
  "Waste Treatment and Disposal",
];
